module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/40e02f053e2601b37494f1ac89221be0.png";